import { createTextComponent } from './createTextComponent';

export const H5 = createTextComponent({
  styleAs: 'h5',
  tag: 'h5',
});
